import React from 'react';
import { useLocation } from 'react-router-dom';

import { reverse } from 'named-urls';

import routes from 'core/routes';

import { useStore } from 'utils/hooks/store';

import SecureRoute from '../SecureRoute';

interface PublicRouteProps {
  children: React.ReactNode;
  path?: string;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children, path }) => {
  const { session } = useStore();
  const location = useLocation();

  // example: /publicSubmission/f98deb5b-2fe7-44ee-86a6-5bdcecc06b0f/
  // or
  // example: /publicForm/f98deb5b-2fe7-44ee-86a6-5bdcecc06b0f/
  // split by `/` returns ['', 'publicSubmission', 'f98deb5b-2fe7-44ee-86a6-5bdcecc06b0f']
  const uuid = location?.pathname.split('/')[2] || '';

  let redirectTo = routes.dashboard.home.toString();

  if (path === routes.publicForm.details.toString()) {
    redirectTo = reverse(routes.publicForm.details, { publicFormId: uuid });
  } else if (path === routes.publicFormList.details.toString()) {
    redirectTo = reverse(routes.publicFormList.details, { publicFormListId: uuid });
  }

  const isAuthorized = redirectTo === routes.dashboard.home.toString() ? () => !session.isAuthenticated : () => true;

  return (
    <SecureRoute isAuthorized={isAuthorized} redirectTo={redirectTo}>
      {children}
    </SecureRoute>
  );
};

export default PublicRoute;
